export default __webpack_public_path__ + "static/media/amazon.b63b4419.jpg";